import React from "react";

let footerLinks = {
    "Brzi Linkovi" : {
        link : {
            name : "Kalkulatori premije" ,
            url : "https://www.lo.co.me/kalkulatori-premije"
        } ,
        link1 : {
            name : "Prijava štete" ,
            url : "https://www.lo.co.me/prijava-stete" } ,
        link2 : {
            name : "Kontaktirajte zastupnika" ,
            url : "https://www.lo.co.me/kontaktirajte-zastupnika"
        } ,
        link3 : {
            name : "Centar za podršku korisnicima" ,
            url : "https://www.lo.co.me/podrska" }
    } ,
    "Lovćen osiguranje AD": {
        link : {
            name : "O Lovćen osiguranju AD" ,
            url : "https://www.lo.co.me/o-nama/lovcen-osiguranje"
        } ,
        link1 : {
            name : "Podaci za identifikaciju" ,
            url : "https://www.lo.co.me/o-nama/podaci-za-identifikaciju" } ,
        link2 : {
            name : "Skupština akcionara" ,
            url : "Skupština akcionara"
        } ,
        link3 : {
            name : "Sprečavanje prevara" ,
            url : "https://www.lo.co.me/o-nama/sprecavanje-prevara" }

    },
    "Grupa Triglav": {
        link : {
            name : "O Grupi" ,
            url : "http://www.triglav.eu/en/about_us/"
        } ,
        link1 : {
            name : "Odnosi sa investitorima" ,
            url : "http://www.triglav.eu/en/investors/" } ,
        link2 : {
            name : "Press centar" ,
            url : "http://www.triglav.eu/en/media/"
        } ,
        link3 : {
            name : "Društvena odgovornost" ,
            url : "http://www.triglav.eu/en/corporate_responsibility/" },
        link4 : {
            name : "Karijera" ,
            url : "http://www.triglav.eu/en/careers/" }

    },
    "Kontakt": {
        link : {
            name : "Poslovne jedinice" ,
            url : "https://www.lo.co.me/prodajna-mreza"
        } ,
        link1 : {
            name : "Sugestije i komentari" ,
            url : "https://www.lo.co.me/o-nama/sugestije-i-komentari" } ,
        link2 : {
            name : "Kontaktirajte nas putem e-maila" ,
            url : "mailto:info@lo.co.me"
        } ,
        link3 : {
            name : "Pratite nas na facebook-u"+ <img src={require("../images/fb.jpg")} width={'32px'} alt={"logo"}/> ,
            url : "https://www.facebook.com/LovcenOsiguranje/" },
    }
};
export default footerLinks;